

import request from "../../request.js"
// 小程序前台首页内容相关 - index
import qs from 'qs'


// 获取最近应急
export const emergency = (data)=>{
    return request({url: "emergency/index",method: 'get',params: data})
}

// 添加应急
export const add = (data)=>{
    return request({url: "emergency/create",method: 'post',data: qs.stringify(data)})
}


// 更新应急
export const update = (data)=>{
    return request({url: "emergency/update",method: 'put',data: qs.stringify(data)})
}

// 删除应急
// export const del = (data)=>{
//     return request({url: "recent-activity/delete",method: 'delete',data: qs.stringify(data)})
// }

// 显示隐藏
export const status = (data)=>{
    return request({url: "emergency/status",method: 'get',params: data})
}